import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "admin-notice-detail" }
const _hoisted_2 = {
  key: 0,
  class: "loading-container"
}
const _hoisted_3 = { class: "notice-container" }
const _hoisted_4 = { class: "notice-header-section" }
const _hoisted_5 = { class: "category-row" }
const _hoisted_6 = { class: "notice-title" }
const _hoisted_7 = { class: "notice-meta-row" }
const _hoisted_8 = { class: "author" }
const _hoisted_9 = { class: "date" }
const _hoisted_10 = { class: "hit" }
const _hoisted_11 = ["innerHTML"]
const _hoisted_12 = {
  key: 0,
  class: "notice-files"
}
const _hoisted_13 = { class: "files-title" }
const _hoisted_14 = { class: "files-grid" }
const _hoisted_15 = ["onClick"]
const _hoisted_16 = {
  key: 1,
  class: "action-row"
}
const _hoisted_17 = { class: "other-notices" }
const _hoisted_18 = { class: "notice-list" }
const _hoisted_19 = ["onClick"]
const _hoisted_20 = { class: "item-title" }
const _hoisted_21 = { class: "item-author" }
const _hoisted_22 = { class: "item-date" }
const _hoisted_23 = {
  key: 2,
  class: "error-container"
}

import { ref, computed, onMounted } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { useStore } from 'vuex';
import axios from 'axios';

interface Notice {
  nc_idx: number;
  nc_type: 'ADMIN' | 'CENTER';
  nc_category: string;
  nc_sisul_code: string | null;
  nc_sisul_name: string | null;
  nc_writer_name: string;
  nc_title: string;
  nc_content: string;
  nc_hit: number;
  nc_wdate: string;
}

interface NoticeFile {
  nf_idx: number;
  nf_original_name: string;
  nf_size: number;
  nf_type: string;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'AdminNoticeDetail',
  setup(__props) {

const route = useRoute();
const router = useRouter();
const store = useStore();

const loading = ref(true);
const notice = ref<Notice | null>(null);
const files = ref<NoticeFile[]>([]);
const otherNotices = ref<Notice[]>([]);
const deleteDialog = ref(false);
const deleting = ref(false);
const snackbar = ref({ show: false, text: '', color: 'info' });

const user = computed(() => store.state.user);
const canEdit = computed(() => {
  if (!notice.value || !user.value) return false;
  if (user.value.m_role === 'admin') return true;
  if (notice.value.nc_type === 'CENTER' && notice.value.nc_sisul_code === user.value.m_sisul_code) return true;
  return false;
});

const loadNotice = async () => {
  const ncIdx = route.params.ncIdx;
  loading.value = true;
  
  try {
    const [detailRes, listRes] = await Promise.all([
      axios.get(`/api/notice/detail/${ncIdx}`, { withCredentials: true }),
      axios.get('/api/notice/list', { params: { page: 1, limit: 20 }, withCredentials: true })
    ]);
    
    if (detailRes.data.success) {
      notice.value = detailRes.data.notice;
      files.value = detailRes.data.files || [];
    }
    
    if (listRes.data.success) {
      otherNotices.value = listRes.data.notices;
    }
  } catch (error) {
    console.error('공지사항 로드 오류:', error);
  } finally {
    loading.value = false;
  }
};

const confirmDelete = () => { deleteDialog.value = true; };

const deleteNotice = async () => {
  if (!notice.value) return;
  deleting.value = true;
  try {
    const response = await axios.delete(`/api/notice/delete/${notice.value.nc_idx}`, { withCredentials: true });
    if (response.data.success) {
      showSnackbar('삭제되었습니다.', 'success');
      setTimeout(() => router.push('/admin/notice'), 1000);
    }
  } catch (error) {
    showSnackbar('삭제에 실패했습니다.', 'error');
  } finally {
    deleting.value = false;
    deleteDialog.value = false;
  }
};

const downloadFile = (file: NoticeFile) => { window.open(`/api/notice/download/${file.nf_idx}`, '_blank'); };
const goBack = () => { router.push('/admin/notice'); };
const goToEdit = () => { if (notice.value) router.push(`/admin/notice/edit/${notice.value.nc_idx}`); };
const goToNotice = (item: Notice | null) => { if (item) router.push(`/admin/notice/${item.nc_idx}`); };

const formatDate = (date: string) => {
  if (!date) return '-';
  const d = new Date(date);
  return `${d.getFullYear()}.${String(d.getMonth()+1).padStart(2,'0')}.${String(d.getDate()).padStart(2,'0')} ${String(d.getHours()).padStart(2,'0')}:${String(d.getMinutes()).padStart(2,'0')}`;
};

const formatShortDate = (date: string) => {
  if (!date) return '-';
  const d = new Date(date);
  return `${d.getMonth()+1}/${d.getDate()}`;
};

const formatListDate = (date: string) => {
  if (!date) return '-';
  const d = new Date(date);
  return `${d.getFullYear()}.${String(d.getMonth()+1).padStart(2,'0')}.${String(d.getDate()).padStart(2,'0')}`;
};

const getFileIcon = (type: string) => {
  if (!type) return 'mdi-file';
  if (type.includes('image')) return 'mdi-file-image';
  if (type.includes('pdf')) return 'mdi-file-pdf-box';
  return 'mdi-file';
};

const getCategoryColor = (c: string) => ({ NOTICE: 'primary', UPDATE: 'info', EVENT: 'success', URGENT: 'error' }[c] || 'grey');
const getCategoryText = (c: string) => ({ NOTICE: '공지사항', UPDATE: '업데이트', EVENT: '이벤트', URGENT: '긴급' }[c] || c);
const getCategoryShort = (c: string) => ({ NOTICE: '공지', UPDATE: '업데이트', EVENT: '이벤트', URGENT: '긴급' }[c] || c);
const showSnackbar = (text: string, color = 'info') => { snackbar.value = { show: true, text, color }; };

onMounted(() => { loadNotice(); });

return (_ctx: any,_cache: any) => {
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!
  const _component_v_chip = _resolveComponent("v-chip")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_dialog = _resolveComponent("v-dialog")!
  const _component_v_snackbar = _resolveComponent("v-snackbar")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (loading.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(_component_v_progress_circular, {
            indeterminate: "",
            color: "primary",
            size: "40"
          })
        ]))
      : (notice.value)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, [
                  _createVNode(_component_v_chip, {
                    color: getCategoryColor(notice.value.nc_category),
                    size: "small",
                    variant: "flat"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(getCategoryText(notice.value.nc_category)), 1)
                    ]),
                    _: 1
                  }, 8, ["color"]),
                  (notice.value.nc_type === 'ADMIN')
                    ? (_openBlock(), _createBlock(_component_v_chip, {
                        key: 0,
                        color: "grey-darken-2",
                        size: "small",
                        variant: "outlined",
                        class: "ml-2"
                      }, {
                        default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                          _createTextVNode(" 전체 ", -1)
                        ]))]),
                        _: 1
                      }))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("h1", _hoisted_6, _toDisplayString(notice.value.nc_title), 1),
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("span", _hoisted_8, _toDisplayString(notice.value.nc_type === 'ADMIN' ? '관리자' : notice.value.nc_sisul_name || '-'), 1),
                  _cache[4] || (_cache[4] = _createElementVNode("span", { class: "divider" }, "|", -1)),
                  _createElementVNode("span", _hoisted_9, _toDisplayString(formatDate(notice.value.nc_wdate)), 1),
                  _cache[5] || (_cache[5] = _createElementVNode("span", { class: "divider" }, "|", -1)),
                  _createElementVNode("span", _hoisted_10, "조회 " + _toDisplayString(notice.value.nc_hit), 1)
                ])
              ]),
              _createElementVNode("div", {
                class: "notice-body ql-editor",
                innerHTML: notice.value.nc_content
              }, null, 8, _hoisted_11),
              (files.value.length > 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                    _createElementVNode("div", _hoisted_13, [
                      _createVNode(_component_v_icon, { size: "16" }, {
                        default: _withCtx(() => [...(_cache[6] || (_cache[6] = [
                          _createTextVNode("mdi-attachment", -1)
                        ]))]),
                        _: 1
                      }),
                      _createTextVNode(" 첨부파일 " + _toDisplayString(files.value.length) + "개 ", 1)
                    ]),
                    _createElementVNode("div", _hoisted_14, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(files.value, (file) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: file.nf_idx,
                          class: "file-chip",
                          onClick: ($event: any) => (downloadFile(file))
                        }, [
                          _createVNode(_component_v_icon, { size: "14" }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(getFileIcon(file.nf_type)), 1)
                            ]),
                            _: 2
                          }, 1024),
                          _createElementVNode("span", null, _toDisplayString(file.nf_original_name), 1)
                        ], 8, _hoisted_15))
                      }), 128))
                    ])
                  ]))
                : _createCommentVNode("", true),
              (canEdit.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                    _createVNode(_component_v_btn, {
                      variant: "outlined",
                      size: "small",
                      onClick: goToEdit
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_icon, {
                          start: "",
                          size: "small"
                        }, {
                          default: _withCtx(() => [...(_cache[7] || (_cache[7] = [
                            _createTextVNode("mdi-pencil", -1)
                          ]))]),
                          _: 1
                        }),
                        _cache[8] || (_cache[8] = _createTextVNode("수정 ", -1))
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_btn, {
                      variant: "outlined",
                      color: "error",
                      size: "small",
                      onClick: confirmDelete
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_icon, {
                          start: "",
                          size: "small"
                        }, {
                          default: _withCtx(() => [...(_cache[9] || (_cache[9] = [
                            _createTextVNode("mdi-delete", -1)
                          ]))]),
                          _: 1
                        }),
                        _cache[10] || (_cache[10] = _createTextVNode("삭제 ", -1))
                      ]),
                      _: 1
                    })
                  ]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_17, [
              _cache[11] || (_cache[11] = _createElementVNode("div", { class: "section-title" }, "공지사항 목록", -1)),
              _createElementVNode("div", _hoisted_18, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(otherNotices.value, (item) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: item.nc_idx,
                    class: _normalizeClass(["notice-list-item", { active: item.nc_idx === notice.value.nc_idx }]),
                    onClick: ($event: any) => (goToNotice(item))
                  }, [
                    _createVNode(_component_v_chip, {
                      color: getCategoryColor(item.nc_category),
                      size: "x-small",
                      variant: "flat",
                      class: "mr-2"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(getCategoryShort(item.nc_category)), 1)
                      ]),
                      _: 2
                    }, 1032, ["color"]),
                    _createElementVNode("span", _hoisted_20, _toDisplayString(item.nc_title), 1),
                    _createElementVNode("span", _hoisted_21, _toDisplayString(item.nc_type === 'ADMIN' ? '관리자' : item.nc_sisul_name || '-'), 1),
                    _createElementVNode("span", _hoisted_22, _toDisplayString(formatListDate(item.nc_wdate)), 1)
                  ], 10, _hoisted_19))
                }), 128))
              ])
            ])
          ], 64))
        : (_openBlock(), _createElementBlock("div", _hoisted_23, [
            _createVNode(_component_v_icon, {
              size: "64",
              color: "grey-lighten-1"
            }, {
              default: _withCtx(() => [...(_cache[12] || (_cache[12] = [
                _createTextVNode("mdi-alert-circle-outline", -1)
              ]))]),
              _: 1
            }),
            _cache[14] || (_cache[14] = _createElementVNode("p", null, "공지사항을 찾을 수 없습니다.", -1)),
            _createVNode(_component_v_btn, {
              color: "primary",
              variant: "tonal",
              onClick: goBack
            }, {
              default: _withCtx(() => [...(_cache[13] || (_cache[13] = [
                _createTextVNode("목록으로", -1)
              ]))]),
              _: 1
            })
          ])),
    _createVNode(_component_v_dialog, {
      modelValue: deleteDialog.value,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((deleteDialog).value = $event)),
      "max-width": "360"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_card, null, {
          default: _withCtx(() => [
            _createVNode(_component_v_card_title, { class: "text-body-1 font-weight-bold" }, {
              default: _withCtx(() => [...(_cache[15] || (_cache[15] = [
                _createTextVNode("공지사항 삭제", -1)
              ]))]),
              _: 1
            }),
            _createVNode(_component_v_card_text, null, {
              default: _withCtx(() => [...(_cache[16] || (_cache[16] = [
                _createTextVNode("이 공지사항을 삭제하시겠습니까?", -1)
              ]))]),
              _: 1
            }),
            _createVNode(_component_v_card_actions, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_spacer),
                _createVNode(_component_v_btn, {
                  variant: "text",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (deleteDialog.value = false))
                }, {
                  default: _withCtx(() => [...(_cache[17] || (_cache[17] = [
                    _createTextVNode("취소", -1)
                  ]))]),
                  _: 1
                }),
                _createVNode(_component_v_btn, {
                  color: "error",
                  variant: "flat",
                  onClick: deleteNotice,
                  loading: deleting.value
                }, {
                  default: _withCtx(() => [...(_cache[18] || (_cache[18] = [
                    _createTextVNode("삭제", -1)
                  ]))]),
                  _: 1
                }, 8, ["loading"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_v_snackbar, {
      modelValue: snackbar.value.show,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((snackbar.value.show) = $event)),
      color: snackbar.value.color,
      timeout: 3000,
      location: "top"
    }, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(snackbar.value.text), 1)
      ]),
      _: 1
    }, 8, ["modelValue", "color"])
  ]))
}
}

})